import { observable, action, computed } from "mobx";

export default class ChangeSingleFieldValueModalStore {
  constructor(
    http,
    userStore,
    dictionaryAdministratorStore,
    projectOwnerStore,
    contentManagementStore,
    createFrameworkProjectStore
  ) {
    this.http = http;
    this.userStore = userStore;
    this.dictionaryAdministratorStore = dictionaryAdministratorStore;
    this.projectOwnerStore = projectOwnerStore;
    this.contentManagementStore = contentManagementStore;
    this.createFrameworkProjectStore = createFrameworkProjectStore;
    this.defaultActionType = "UpdateOrchestration"
    this.actionType = this.defaultActionType
    this.otherData = {}
  }

  @observable visible = false;

  @observable
  modalData = {
    title: "",
    fieldLabel: "",
    orchestrationType: "",
    currentFieldValue: "",
    newFieldValue: "",
    optionalTidFromCM: "",
    options: undefined,
  };

  @action
  saveNewFieldValue = () => {
    const json = {}
    if (this.actionType) {
      json.actionType = this.actionType
      for (const [key, value] of Object.entries(this.getPayload())) {
        json[key] = value
      }
    } else {
      json.actionType = this.defaultActionType
      json.orchestration = this.getOrchestration()
    }
    this.http.func_sendGeneralMessage(json);
  };

  getOrchestration = () => {
    let orchestration = null;
    const { getTableData } = this.contentManagementStore;
    switch (this.modalData.orchestrationType) {
      case "Actor":
        const { get_obj_userData } = this.userStore;
        orchestration = {
          type: "Actor",
          tid: get_obj_userData.actor.tid,
          name: this.modalData.newFieldValue,
          login: get_obj_userData.actor.login,
          authSystem: get_obj_userData.actor.authSystem,
        };
        return orchestration;
      case "Branch":
        const { get_ob_selectedBranchData } = this.dictionaryAdministratorStore;
        orchestration = {
          type: "Branch",
          tid: get_ob_selectedBranchData.bid,
          mid: get_ob_selectedBranchData.maintenanceAgencyId,
          pid: get_ob_selectedBranchData.projectId,
          name:
            this.modalData.fieldLabel === "Branch Name"
              ? this.modalData.newFieldValue
              : get_ob_selectedBranchData.branchName,
          description:
            this.modalData.fieldLabel === "Description"
              ? this.modalData.newFieldValue
              : get_ob_selectedBranchData.description,
          branchType: get_ob_selectedBranchData.branchType,
          status: get_ob_selectedBranchData.branchStatus,
          creationDate: get_ob_selectedBranchData.branchCreationDate,
        };
        return orchestration;
      case "Project":
        const { get_obj_selected_project } = this.projectOwnerStore;
        orchestration = {
          type: "Project",
          tid: get_obj_selected_project.project.tid,
          mid: get_obj_selected_project.maintenanceAgency.tid,
          name:
            this.modalData.fieldLabel === "Project Name"
              ? this.modalData.newFieldValue
              : get_obj_selected_project.project.name,
          description:
            this.modalData.fieldLabel === "Description"
              ? this.modalData.newFieldValue
              : get_obj_selected_project.project.description || "-",
          projectType: get_obj_selected_project.project.projectType,
          isNonFrameworkType:
            get_obj_selected_project.project.isNonFrameworkType,
          status: get_obj_selected_project.project.status,
          framework: get_obj_selected_project.project.framework,
          frameworks: get_obj_selected_project.project.frameworks ? get_obj_selected_project.project.frameworks : null,
          frameworkFrom: get_obj_selected_project.project.frameworkFrom,
          creationDate: get_obj_selected_project.project.creationDate,
          finalizationDate: get_obj_selected_project.project.finalizationDate,
          isFastTrack: get_obj_selected_project.project.isFastTrack,
          areBusinessConstraintsDisabled: get_obj_selected_project.project.areBusinessConstraintsDisabled,
        };
        return orchestration;
      case "MaintenanceAgency":
        const editedMaintenanceAgencyData = getTableData(
          "MaintenanceAgency"
        ).data.results.filter(
          (result) => result.tid === this.modalData.optionalTidFromCM
        )[0];
        orchestration = {
          type: "MaintenanceAgency",
          tid: editedMaintenanceAgencyData.tid,
          name:
            this.modalData.fieldLabel === "Maintenance Agency Name"
              ? this.modalData.newFieldValue
              : editedMaintenanceAgencyData.name,
          code:
            this.modalData.fieldLabel === "Maintenance Agency Code"
              ? this.modalData.newFieldValue
              : editedMaintenanceAgencyData.code,
          description:
            this.modalData.fieldLabel === "Maintenance Agency Description"
              ? this.modalData.newFieldValue
              : editedMaintenanceAgencyData.description,
          maintenanceAgencyId: editedMaintenanceAgencyData.maintenanceAgencyId,
        };
        return orchestration;
      case "Framework":
        const editedFrameworkData = getTableData(
          "Framework"
        ).data.results.filter(
          (result) => result.tid === this.modalData.optionalTidFromCM
        )[0];
        orchestration = {
          type: "Framework",
          tid: editedFrameworkData.tid,
          mid: editedFrameworkData.mid,
          frameworkId: editedFrameworkData.frameworkId,
          maintenanceAgencyId: editedFrameworkData.maintenanceAgencyId,
          name:
            this.modalData.fieldLabel === "Framework Name"
              ? this.modalData.newFieldValue
              : editedFrameworkData.name,
          code:
            this.modalData.fieldLabel === "Framework Code"
              ? this.modalData.newFieldValue
              : editedFrameworkData.code,
          description:
            this.modalData.fieldLabel === "Framework Description"
              ? this.modalData.newFieldValue
              : editedFrameworkData.description,
          frameworkStatus: editedFrameworkData.frameworkStatus,
          frameworkType:
            this.modalData.fieldLabel === "Framework FrameworkType"
              ? this.modalData.newFieldValue
              : editedFrameworkData.frameworkType,
          reportingPopulation:
            this.modalData.fieldLabel === "Framework ReportingPopulation"
              ? this.modalData.newFieldValue
              : editedFrameworkData.reportingPopulation,
          otherLinks:
            this.modalData.fieldLabel === "Framework OtherLinks"
              ? this.modalData.newFieldValue
              : editedFrameworkData.otherLinks,
          orderNo:
            this.modalData.fieldLabel === "Framework OrderNo"
              ? this.modalData.newFieldValue
              : editedFrameworkData.orderNo,
        };
        return orchestration;
      default:
        return;
    }
  };

  getPayload = () => {
    switch(this.modalData.orchestrationType) {
      case "Release":
        return {
          bid: this.otherData.tid,
          name: this.modalData.newFieldValue
        }
      default:
        break;  
    }
  }

  @action
  setupModalData = (
    title,
    fieldLabel,
    currentFieldValue,
    orchestrationType,
    optionalTidFromCM,
    overrideActionType
  ) => {
    this.modalData = {
      ...this.modalData,
      title: title,
      fieldLabel: fieldLabel,
      currentFieldValue: currentFieldValue,
      orchestrationType: orchestrationType,
      optionalTidFromCM: optionalTidFromCM,
      options: undefined,
    };
    this.actionType = overrideActionType
  };

  @action
  setOrchestrationType = (orchestrationType) => {
    this.modalData = {
      ...this.modalData,
      orchestrationType,
    };
  };

  @action
  changeFieldValue = (newValue) => {
    this.modalData.newFieldValue = newValue;
  };

  @action
  toggleVisibility = () => {
    this.visible = !this.visible;
    if (!this.visible) {
      this.modalData = {
        title: "",
        fieldLabel: "",
        orchestrationType: "",
        currentFieldValue: "",
        newFieldValue: "",
        options: undefined,
      };
      this.actionType = this.defaultActionType
      this.otherData = {}
    }
  };

  @action
  prepareModalWithRestrictedValue = () => {
    switch(this.modalData.fieldLabel) {
      case "Framework FrameworkType":
        this.modalData.options = this.createFrameworkProjectStore.getFrameworksTypes;
        break;
      default:
        this.modalData.options = undefined;
    }
  }

  @action
  setOtherData = (data) => {
    this.otherData = data
  }

  @computed
  get getModalData() {
    return this.modalData;
  }

  @computed
  get isVisible() {
    return this.visible;
  }
}
